'use es6';

import http from 'hub-http/clients/apiClient';
import { ACADEMY_CATALOG_SERVICE_URI } from '../constants/ApiConstants';
const TRACK_API_URL = `${ACADEMY_CATALOG_SERVICE_URI}/tracks`;
export const LESSON_API_URL = `${ACADEMY_CATALOG_SERVICE_URI}/lessons`;
export function postTrackEngagment(trackId) {
  return http.post(`${TRACK_API_URL}/${trackId}/conversion`);
}
export function postLessonEngagment(lessonId) {
  return http.post(`${LESSON_API_URL}/${lessonId}/conversion`);
}